<template>
  <div class="error-box">
    <div class="fail_">
      <img src="../assets/fail.png" alt="fail" />
      <div class="text_ text_1">出错了！投保失败！</div>
      <div class="text_info">
        <div class="text_">错误原因：{{$route.query.error||'服务端异常，请联系管理员！'}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      policyId: ''
    }
  },
  mounted() {
    const { policyId } = this.$route.query;
    this.policyId = policyId;
    this.$nextTick(() => {
      window.clairvoyanceRecord.save();
      this.$refs.success.click();
      let policyId = this.policyId.split(',') && this.policyId.split(',')[0];
      if (window.clairvoyanceRecord) {
        window.clairvoyanceRecord.finish({
          oldPolicy: sessionStorage.getItem('oldPolicyId'),
          policyId: policyId
        });
        console.log('%cclairvoyanceRecordFinish == > 结束录制', 'color: green');
      } else {
        setTimeout(function () {
          if (window.clairvoyanceRecord) {
            window.clairvoyanceRecord.finish({
              policyId: policyId
            });
            console.log('%cclairvoyanceRecordFinish == > 结束录制', 'color: green');
          }
        }, 1000);
      }
    })
  }
};
</script>

<style lang="scss" scoped>
.error-box{
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  padding-top: 150px;
  .fail_ {
    min-width: 500px;
    width: 500px;
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      width: 228px;
      height: 186px;
    }
    .text_info {
      margin: 10px 0;
    }
    .text_ {
      font-size: 11px;
      font-family: Microsoft YaHei UI;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
    }
    .text_1 {
      font-size: 18px;
      font-weight: bold;
      color: rgba(254, 152, 69, 1);
    }
  }
}
</style>
